module.exports = __webpack_public_path__ + "img/text_medium.f444cc48.webp";